export default {
  red: {
    path:
      "M0 -8q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "red",
    fillOpacity: 0.6,
    strokeWeight: 0,
    rotation: 0,
    scale: 3,
  },

  green: {
    path:
      "M0 -8q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "green",
    fillOpacity: 0.6,
    strokeWeight: 0,
    rotation: 0,
    scale: 3,
  },

  yellow: {
    path:
      "M0 -8q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "yellow",
    fillOpacity: 0.6,
    strokeWeight: 0,
    rotation: 0,
    scale: 3,
  },

  gateway: {
    path:
      "M3225 4468 c-73 -82 -132 -194 -167 -318 -6 -25 -12 -101 -12 -170 -1 -103 3 -138 23 -200 33 -106 94 -219 155 -286 50 -55 55 -58 82 -49 47 17 44 52 -10 115 -203 238 -206 599 -6 833 50 58 61 92 38 115 -25 25 -56 12 -103 -40z M4366 4499 c-19 -27 -12 -43 41 -104 60 -68 118 -192 139 -294 21 -105 14 -209 -21 -320 -25 -78 -100 -207 -143 -245 -43 -38 -19 -105 32 -92 61 15 187 221 222 361 22 90 22 256 1 347 -29 119 -92 238 -175 330 -39 43 -73 49 -96 17z M3388 4319 c-117 -123 -160 -348 -98 -511 26 -70 93 -173 126 -195 22 -14 26 -14 49 1 34 22 31 50 -10 100 -19 23 -47 69 -62 102 -25 53 -28 70 -28 164 0 97 2 110 31 170 17 36 45 82 63 102 34 39 39 68 15 92 -24 25 -44 19 -86 -25z M4228 4348 c-31 -25 -27 -45 22 -112 65 -89 85 -150 85 -256 0 -106 -20 -167 -85 -255 -50 -70 -55 -97 -18 -116 26 -14 58 9 111 77 138 181 122 464 -37 637 -37 39 -53 44 -78 25z M3547 4153 c-43 -46 -67 -110 -67 -183 0 -128 93 -253 148 -198 19 19 14 44 -18 95 -42 66 -42 142 0 204 32 47 37 78 18 97 -20 20 -53 14 -81 -15z M4064 4155 c-16 -25 -16 -27 17 -73 30 -42 34 -54 34 -112 0 -50 -5 -73 -20 -94 -42 -60 -45 -69 -31 -91 23 -35 60 -31 95 12 78 95 79 251 1 346 -38 45 -72 49 -96 12z M3792 3987 c-22 -23 -22 -28 -22 -376 0 -350 0 -353 -22 -384 l-23 -32 0 -620 0 -620 -1671 -5 -1670 -5 -42 -28 c-23 -15 -51 -45 -62 -67 -19 -38 -20 -57 -20 -500 0 -364 3 -467 14 -493 17 -43 76 -93 123 -106 23 -7 170 -11 373 -11 l335 0 15 -47 c11 -34 25 -54 50 -71 34 -22 41 -23 208 -20 l174 3 34 37 c23 26 34 47 34 68 l0 30 940 0 940 0 0 -30 c0 -21 11 -42 34 -68 l34 -37 167 -3 c115 -2 177 0 197 9 34 14 66 56 74 98 l7 31 336 0 c204 0 351 4 374 11 47 13 106 63 123 106 11 26 14 129 14 493 0 443 -1 462 -20 500 -11 22 -39 52 -62 67 l-42 28 -380 3 -381 3 0 618 0 619 -22 31 c-23 30 -23 33 -23 384 0 343 -1 355 -21 381 -27 35 -86 36 -117 3z m656 -2639 l-3 -253 -1885 0 -1885 0 -3 253 -2 252 1890 0 1890 0 -2 -252z M915 1415 c-35 -34 -33 -78 4 -116 33 -32 58 -36 100 -14 76 39 43 155 -44 155 -25 0 -44 -8 -60 -25z M1262 1433 c-17 -6 -42 -57 -42 -83 0 -12 14 -35 30 -52 27 -26 36 -30 68 -25 46 8 72 38 72 86 0 49 -33 81 -81 80 -19 0 -40 -3 -47 -6z M1583 1418 c-28 -31 -35 -60 -24 -91 34 -89 164 -62 164 34 0 69 -94 107 -140 57z M3480 1345 l0 -95 355 0 355 0 0 95 0 95 -355 0 -355 0 0 -95z",
    fillColor: "blue",
    fillOpacity: 0.7,
    strokeWeight: 0,
    rotation: 180,
    scale: 0.009,
  },

  hidden: {
    path:
      "M0 -8q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "yellow",
    fillOpacity: 0,
    strokeWeight: 0,
    rotation: 0,
    scale: 3,
  },
};
